export default __webpack_public_path__ + "locales/uk-UA/UploadPanel.json?hash=850912356602400814700bcab625f707";